export default __webpack_public_path__ + "static/media/QK_9362.bc28b88d.jpg";